import { forwardRef, type Ref, type SVGProps } from "react";
const IconSortDescendingOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29.693 21.188v.001a1.07 1.07 0 0 1 0 1.5l-6.895 7.001A1.13 1.13 0 0 1 22 30a1.07 1.07 0 0 1-.798-.31l-6.896-7.002a1.07 1.07 0 0 1 0-1.499l.002-.001a1.035 1.035 0 0 1 1.478 0l5.228 5.313V3a.987.987 0 1 1 1.973 0v23.501l5.227-5.313a1.036 1.036 0 0 1 1.479 0M17 11H3a1 1 0 1 1 0-2h14a1 1 0 1 1 0 2M3 15h8a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2m4 6H3a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2" />
  </svg>
);
const ForwardRef = forwardRef(IconSortDescendingOutlineSVG);
ForwardRef.displayName = "IconSortDescendingOutline";
export { ForwardRef as IconSortDescendingOutline };
